import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["color", "size", "strokeWidth", "absoluteStrokeWidth", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * lucide-react v0.292.0 - ISC
 */
import { forwardRef, createElement } from 'react';
import defaultAttributes from './defaultAttributes.js';

var toKebabCase = function toKebabCase(string) {
  return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
};

var createLucideIcon = function createLucideIcon(iconName, iconNode) {
  var Component = forwardRef(function (_ref, ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? "currentColor" : _ref$color,
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 24 : _ref$size,
        _ref$strokeWidth = _ref.strokeWidth,
        strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
        absoluteStrokeWidth = _ref.absoluteStrokeWidth,
        children = _ref.children,
        rest = _objectWithoutProperties(_ref, _excluded);

    return createElement("svg", _objectSpread(_objectSpread({
      ref: ref
    }, defaultAttributes), {}, {
      width: size,
      height: size,
      stroke: color,
      strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
      className: "lucide lucide-".concat(toKebabCase(iconName))
    }, rest), [].concat(_toConsumableArray(iconNode.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          tag = _ref3[0],
          attrs = _ref3[1];

      return createElement(tag, attrs);
    })), _toConsumableArray((Array.isArray(children) ? children : [children]) || [])));
  });
  Component.displayName = "".concat(iconName);
  return Component;
};

export { createLucideIcon as default, toKebabCase };